import React, { useId } from 'react';
import type { ChatConversationProps } from './ChatConversation';
import { ChatConversation } from './ChatConversation';
import { VBox } from '../layout';
import { intl } from '../../lib';

export type ChatConversationListProps = {
  conversations: Array<ChatConversationProps>;
  selectedRoomId: string | null;
  setSelectedRoomId: (id: string) => void;
};

export function ChatConversationList(
  props: ChatConversationListProps
): React.JSX.Element {
  const sortedConversations = React.useMemo(() => {
    return [...props.conversations].sort((a, b) => {
      if (a.pinned && !b.pinned) return -1; // Pinned conversations come first
      if (!a.pinned && b.pinned) return 1; // Non-pinned conversations come later
      return new Date(b.date).getTime() - new Date(a.date).getTime(); // Sort by latest date
    });
  }, [props.conversations]);

  const listId = useId();

  return (
    <VBox className="ehs-chat-conversation-list">
      <h2 id={listId}>{intl('common.chatmessage.title')}</h2>
      <VBox role="list" aria-labelledby={listId}>
        {sortedConversations.map(conv => {
          return (
            <ChatConversation
              key={conv.roomId ?? conv.header.toLowerCase().trim()}
              {...conv}
              selected={props.selectedRoomId === conv.roomId}
              role="listitem"
            />
          );
        })}
      </VBox>
    </VBox>
  );
}
